// Single source of truth for the default/last-selected store used across all NTS modules
// (Questions, Videos, Products, Blogs, Buckets, Product Types, ...).
// Change DEFAULT_STORE_LABEL in one place to change the default store everywhere.
export const DEFAULT_STORE_LABEL = "US";

// One shared localStorage key so picking a store in any NTS module applies to all of them.
// Always stores the store LABEL (e.g. "US", "UAT") — modules needing a hash convert via hashForLabel().
export const SHARED_STORE_LS_KEY = "newToStrum.lastStoreLabel";
